import PropTypes from 'prop-types'
import React from 'react'
import { Pagination as BsPagination } from 'react-bootstrap'
import { useHistory, useLocation } from 'react-router-dom'

function Pagination(props) {
  const { count, page, perPage } = props
  const { pathname } = useLocation()
  const history = useHistory()
  const pages = Math.ceil(count / perPage)
  const hasPrev = page > 1
  const hasNext = page < pages
  const lots = pages > 5

  // react-bootstrap doesn't have an `as` param for pagination, so we
  // set both the `href` and the `onClick` – the former to make it look
  // like a link to the user, and the latter to navigate using
  // react-router.
  const getNavigationProps = newPage => {
    const href = `${pathname}${newPage === 1 ? '' : '?page=' + newPage}`
    return {
      href,
      onClick: e => {
        e.preventDefault()
        history.push(href)
      },
    }
  }

  return (
    <BsPagination className="mt-3">
      {lots ? (
        <BsPagination.First disabled={!hasPrev} {...getNavigationProps(1)} />
      ) : null}
      <BsPagination.Prev
        disabled={!hasPrev}
        {...getNavigationProps(page - 1)}
      />
      {lots ? (
        <BsPagination.Item active>{page}</BsPagination.Item>
      ) : (
        Array(pages)
          .fill()
          .map((_, i) => (
            <BsPagination.Item
              key={i + 1}
              active={i + 1 === page}
              {...getNavigationProps(i + 1)}
            >
              {i + 1}
            </BsPagination.Item>
          ))
      )}
      <BsPagination.Next
        disabled={!hasNext}
        {...getNavigationProps(page + 1)}
      />
      {lots ? (
        <BsPagination.Last disabled={!hasNext} {...getNavigationProps(pages)} />
      ) : null}
    </BsPagination>
  )
}

Pagination.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
}

export default Pagination
